import { createSelector } from 'reselect';
import GoalsConstants from 'Shared/constants/Goals.constants';

// TODO (josh) : this key should come from a constant
const getGoalsItems = state => state.goalsItems;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getSlugParam = createParameterSelector(params => params.slug);
const getUserIdParam = createParameterSelector(params => params.userId);
const getCompleteParam = createParameterSelector(params => params.complete);
const getWorkspaceSlugParam = createParameterSelector(params => params.workspaceSlug);
const getPrivacySettingParam = createParameterSelector(params => params.privacySetting);
const getUsersParam = createParameterSelector(params => params.users);
const getParentIdParam = createParameterSelector(params => params.parentId);
const getIdParam = createParameterSelector(params => params.id);

export const getAllGoals = createSelector([getGoalsItems], goals => {
  return goals.get(GoalsConstants.State.GOALS_BY_GOAL_SLUG);
});

export const getGoalBySlug = createSelector([getAllGoals, getSlugParam], (goals, slug) => goals.get(slug));

export const getGoalsByComplete = createSelector([getAllGoals, getCompleteParam], (goals, complete) => {
  return goals.filter(goal => goal.get('complete') === complete).sortBy(goal => goal.get('position'));
});

export const getGoalById = createSelector([getAllGoals, getIdParam], (goals, id) => {
  return goals.find(goal => goal.get('id') === id);
});

export const getGoalsByParentId = createSelector([getAllGoals, getParentIdParam], (goals, parentId) => {
  return goals.filter(goal => goal.get('parentId') === parentId && parentId).sortBy(goal => goal.get('endDate'));
});

export const getGoalsByUserId = createSelector([getAllGoals, getUserIdParam], (goals, userId) => {
  return goals.filter(goal => goal.get('assigneeId') === userId).sortBy(goal => goal.get('position'));
});

export const getGoalsByUserIdAndComplete = createSelector([getGoalsByUserId, getCompleteParam], (goals, complete) => {
  return goals.filter(goal => goal.get('complete') === complete).sortBy(goal => goal.get('position'));
});

export const getGoalsByUserIdAndCompleteAndWorkspace = createSelector(
  [getGoalsByUserIdAndComplete, getWorkspaceSlugParam],
  (goals, workspaceSlug) => {
    return goals.filter(goal => goal.get('workspaceSlug') === workspaceSlug).sortBy(goal => goal.get('position'));
  }
);

export const getGoalsByWorkspaceAndComplete = createSelector(
  [getAllGoals, getWorkspaceSlugParam, getCompleteParam],
  (goals, workspaceSlug, complete) => {
    return goals
      .filter(goal => goal.get('workspaceSlug') === workspaceSlug && goal.get('complete') === complete)
      .sortBy(goal => goal.get('position'));
  }
);

export const getGoalsByUserIdAndPrivacySettingAndComplete = createSelector(
  [getGoalsByUserIdAndComplete, getPrivacySettingParam],
  (goals, privacySetting) => {
    return goals.filter(goal => goal.get('privacySetting') === privacySetting).sortBy(goal => goal.get('position'));
  }
);

// these selectors kinda stinks :( because it's not generic and built for one particular use case  (josh)
// not to be used anywhere else
export const getGoalsForWorkspace = createSelector(
  [getGoalsByUserIdAndCompleteAndWorkspace, getGoalsByUserIdAndPrivacySettingAndComplete],
  (workspaceGoals, userPublicGoals) => {
    return workspaceGoals.merge(userPublicGoals);
  }
);

// these selectors kinda stinks :( because it's not generic and built for one particular use case  (josh)
// not to be used anywhere else
export const getGoalsByListOfUsersAndPrivacy = createSelector(
  [getAllGoals, getUsersParam, getPrivacySettingParam, getCompleteParam],
  (goals, users, privacy, complete) => {
    return goals
      .filter(goal => users.map(user => user.id === goal.get('assigneeId')))
      .filter(goal => goal.get('privacySetting') === privacy)
      .filter(goal => goal.get('complete') === complete);
  }
);
// not to be used anywhere else
